<div class="-mt-6 mb-5">
<div class="mb-3 w-full text-center text-lg">{{'DEPOSIT.NO_DEPOSIT' | depositTranslate}}</div>
<p-button [label]="'common.BUTTONS.BTN_ADD_DEPOSIT' | depositTranslate" icon="fa fa-plus" (click)="addDepositModal()" styleClass="p-button-outlined text-sm surface-0" aria-label="add-deposit-button" />
</div>